<template>
  <div>
    <v-toolbar v-for="(item, i) in myMarketData" :key="i" light dense flat>
      <v-btn
        class="caption ma-0 px-1 py-2 text-capitalize text-left flex-grow-1"
        color="transparent"
        depressed
        tile
        height="100%"
        :to="`/sportsbook/${item.eventTypeId}/${item.competitionId}/${item.eventId}`"
      >
        <span class="text-left" style="width: 100%">{{ item.name }}</span>
      </v-btn>
      <favorite-btn
        :is-favorite="item.eventId ? true : false"
        :market-id="+item.eventId"
        :favorite="{
          id: item.markets[0].marketId,
          groupById: item.eventTypeId
        }"
      />
    </v-toolbar>
  </div>
</template>
<script>
import FavoriteBtn from '@/components/FavoriteBtn'
export default {
  components: { FavoriteBtn },
  props: {
    myMarketData: { type: Array, default: () => [], required: true }
  }
}
</script>
